// Fuente de datos del CV imprimible (ruta /cv).
//
// Contenido estático: NO se toca Supabase aquí. Edita los textos en este
// archivo. El formato de "rich text" usa marcadores mínimos:
//   **negrita**   y   *cursiva*
// (no hay asteriscos literales en el contenido, así que es seguro).

// Ruta de la fotografía. Coloca tu foto en `public/foto-hector.jpg`
// (o cambia esta ruta / usa una URL absoluta). process.env.PUBLIC_URL
// respeta el "homepage" del proyecto al desplegar.
export const photoUrl = `${process.env.PUBLIC_URL || ""}/foto-hector.jpg`;
export const photoAlt = "Fotografía de Héctor Durán";

export const profile = {
  name: "HÉCTOR DURÁN",
  title: "DESARROLLADOR FULL-STACK · .NET / ANGULAR · ENFOQUE EN SEGURIDAD",
};

// Cada contacto: icon (clave lógica), texto visible y href opcional.
// href null => se muestra como texto (no enlace). Nunca se muestra la URL cruda.
export const contact = [
  { icon: "mail", label: "hduranc24@gmail.com", href: "mailto:hduranc24@gmail.com" },
  { icon: "phone", label: "+507 6927-1957", href: "tel:+50769271957" },
  { icon: "location", label: "Ciudad de Panamá, Panamá", href: null },
  { icon: "website", label: "hectordurancv.com", href: "https://hectordurancv.com" },
  { icon: "github", label: "github.com/hectorduran2801", href: "https://github.com/hectorduran2801" },
  {
    icon: "linkedin",
    label: "linkedin.com/in/hector-duran-51609a213",
    href: "https://www.linkedin.com/in/hector-duran-51609a213",
  },
];

// Habilidades agrupadas por categoría. `highlight` marca la caja destacada.
export const skills = [
  { category: "Lenguajes", items: "C#, TypeScript, JavaScript (ES6+), Java, PHP, SQL" },
  { category: "Backend", items: ".NET / ASP.NET Core, Node.js, NestJS, Quarkus, REST APIs, Sequelize" },
  { category: "Frontend", items: "Angular, RxJS, Ionic, Blazor, React, HTML5, CSS3 / Sass, PWA" },
  { category: "Bases de datos", items: "SQL Server, PostgreSQL, Supabase, MySQL, Oracle" },
  {
    category: "Seguridad",
    items: "Secure coding, OWASP, autenticación/autorización, RBAC, Row-Level Security",
    highlight: true,
  },
  { category: "DevOps / Cloud", items: "Git, GitHub, GitLab, Bitbucket, Azure, Nginx, CI/CD" },
  { category: "Metodologías", items: "Scrum / Agile, Jira, Postman" },
];

export const languages = [
  { name: "Español", level: "Nativo" },
  { name: "Inglés", level: "Lectura técnica competente; conversacional básico (en mejora)" },
];

export const certifications = [
  { name: "Cybersecurity Essentials", issuer: "Cisco Networking Academy" },
  { name: "Certificación Laravel", issuer: "U. Tecnológica de Panamá" },
  { name: "ReactJS de cero a experto · JavaScript Moderno · Unity", issuer: "Udemy" },
];

export const profileText =
  "Desarrollador Full-Stack *mid-level* especializado en el ecosistema **.NET / C#** y " +
  "**Angular**, con **Maestría en Seguridad Informática**. Diseño y despliego aplicaciones " +
  "web y PWA seguras de extremo a extremo — de APIs REST y modelado de datos a interfaces " +
  "Angular — aplicando *secure coding* y control de accesos (RBAC/RLS). **+4 años** " +
  "entregando software para banca, aduanas/gobierno, la Autoridad del Canal de Panamá y e-commerce.";

// Experiencia laboral en orden CRONOLÓGICO: de la más antigua (arriba) a la
// más reciente (abajo). El CV las muestra INVERTIDAS (la más nueva primero),
// así que para agregar un puesto nuevo solo añádelo al FINAL de este arreglo
// y aparecerá de primero en el CV.
//
// Campos por experiencia (todos editables):
//   company        Nombre de la empresa (obligatorio).
//   companyUrl     URL oficial de la empresa. null/"" => se muestra como texto.
//                  Ej.: companyUrl: "https://www.empresa.com"
//   role           Cargo / puesto.
//   employmentType "Turno" o modalidad: "Tiempo completo", "Freelance", … (opcional).
//   period         Rango de fechas (texto libre).
//   location       Ubicación. null/"" => no se muestra. Ej.: "Ciudad de Panamá, Panamá".
//                  NOTA: asumí "Ciudad de Panamá, Panamá"; corrige las que fueron
//                  remotas o en otra ciudad.
//   bullets        Logros (soporta **negrita** y *cursiva*).
export const experience = [
  {
    company: "Autoridad del Canal de Panamá (ACP)",
    companyUrl: null, // pendiente: URL oficial (ej. "https://pancanal.com")
    role: "Práctica Profesional · Full-Stack",
    employmentType: null,
    period: "sept 2021 – mar 2022",
    location: "Ciudad de Panamá, Panamá",
    bullets: [
      "Desarrollé **desde cero** una aplicación de gestión de mantenimiento (escritorio VB.NET + web .NET MVC / C#, SQL Server) para dar seguimiento a la distribución y el servicio de **aceites y lubricantes de la maquinaria del Canal**.",
      "Gestioné el levantamiento de requerimientos en Jira.",
    ],
  },
  {
    company: "CrimsonLogic",
    companyUrl: null, // pendiente: URL oficial de la empresa
    role: "Desarrollador Backend",
    employmentType: null,
    period: "jun 2022 – jun 2023",
    location: "Ciudad de Panamá, Panamá",
    bullets: [
      "Mantuve y desarrollé nuevas funcionalidades para un **sistema de aduanas del gobierno** en Java (JSF) y Oracle, dando soporte a operaciones aduaneras nacionales.",
      "Resolví incidencias y optimicé consultas Oracle para mejorar el rendimiento y la estabilidad del sistema.",
    ],
  },
  {
    company: "3TECH Moving Technology",
    companyUrl: null, // pendiente: URL oficial de la empresa
    role: "Desarrollador Full-Stack",
    employmentType: null,
    period: "sept 2022 – oct 2024",
    location: "Ciudad de Panamá, Panamá",
    bullets: [
      "Desarrollé **desde cero** la tienda e-commerce del cliente (WordPress / WooCommerce), lanzando su plataforma de ventas online.",
      "Construí una app móvil complementaria en Flutter que extendió la tienda web a dispositivos móviles.",
      "Entregué integraciones en C# para clientes del **sector financiero** (ENA Corredores, Western Union).",
    ],
  },
  {
    company: "Soluciones e Integraciones Eléctricas S.A.",
    companyUrl: null, // pendiente: URL oficial de la empresa
    role: "Full-Stack",
    employmentType: "Freelance",
    period: "feb 2022 – Actualidad",
    location: "Ciudad de Panamá, Panamá",
    bullets: [
      "Entrego proyectos *end-to-end* para **4–5 clientes**, cubriendo frontend y backend con Angular, React, Node.js / NestJS, C# y PHP.",
    ],
  },
  {
    company: "Bluecore S.A.",
    companyUrl: null, // pendiente: URL oficial de la empresa
    role: "Desarrollador Full-Stack",
    employmentType: "Tiempo completo",
    period: "sept 2024 – Actualidad",
    location: "Ciudad de Panamá, Panamá",
    bullets: [
      "Desarrollo el **backend de una plataforma del sector bancario** en C# / .NET y Quarkus, construyendo APIs REST para operaciones críticas en un **entorno de alta seguridad**.",
      "Trabajo *full-stack* sobre múltiples módulos, desarrollando interfaces en Angular, Ionic y Blazor con enfoque *mobile-first*.",
      "Implementé Progressive Web Apps (PWA) para llevar el sistema a dispositivos móviles.",
    ],
  },
];

export const featuredProject = {
  title: "OrgCore",
  subtitle: "SaaS multi-tenant de gestión organizacional",
  tag: "Proyecto propio",
  stack: "Angular · Supabase / PostgreSQL · PWA · TypeScript",
  bullets: [
    "Diseñé y desarrollé un SaaS *multi-tenant* con **Row-Level Security (RLS)** y control de acceso por roles para aislar datos entre organizaciones.",
    "Endurecí el modelo de permisos (auditoría por rol), **cerrando escaladas de privilegios** mediante RPCs seguros — aplicando mi Maestría en Seguridad.",
    "Construí el portal de autoservicio (carnet digital, asistencias, pagos) como PWA *mobile-first*.",
  ],
};

// Formación en orden CRONOLÓGICO (la más antigua arriba). Igual que la
// experiencia, el CV la muestra INVERTIDA: añade la más reciente al FINAL y
// aparecerá de primera.
export const education = [
  {
    title: "Licenciatura en Desarrollo de Software",
    institution: "Universidad Tecnológica de Panamá",
    period: "ene 2018 – dic 2022",
  },
  {
    title: "Maestría en Seguridad Informática",
    institution: "Universidad Tecnológica de Panamá",
    period: "ene 2023 – ene 2025",
  },
];

export const educationNote = "Práctica Profesional en la Autoridad del Canal de Panamá (ACP).";
